/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPSOURCEOFWEALTH = {
    Savings: 'S',
    RetirementSavings: 'R',
    ProceedsOfAPolicy: 'PPO',
    Inheritance: 'I',
    ProceedsOfAnInvestment: 'P',
    DivorceSettlement: 'D',
    SaleProceeds: 'SP',
    Donation: 'DO',
    Other: 'O'
} as const;
export type IAPSOURCEOFWEALTH = typeof IAPSOURCEOFWEALTH[keyof typeof IAPSOURCEOFWEALTH];


export function IAPSOURCEOFWEALTHFromJSON(json: any): IAPSOURCEOFWEALTH {
    return IAPSOURCEOFWEALTHFromJSONTyped(json, false);
}

export function IAPSOURCEOFWEALTHFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPSOURCEOFWEALTH {
    return json as IAPSOURCEOFWEALTH;
}

export function IAPSOURCEOFWEALTHToJSON(value?: IAPSOURCEOFWEALTH | null): any {
    return value as any;
}

